import React from 'react';
import {
  Box,
} from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Pagination, PaginationItem } from '@material-ui/lab';
import { AllConcessionsII } from '../../../../interfaces/concessoes';

interface Props {
  setPage: (page: number) => void;
  listItem?: AllConcessionsII;
}

const useStyles = makeStyles((theme: Theme) => ({
  main: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 62,
    borderRadius: '50%',
    color: '#fff',
    '& .Mui-selected': {
      backgroundColor: theme.palette.primary.main,
      borderRadius: '50%',
    },
  },
  paginationItem: {
    color: '#9E9E9E',
  },
  paginationSelected: {
    color: theme.palette.text.primary,
  },
}));

export default function PaginationService({
  setPage,
  listItem,
}: Props): JSX.Element {
  const classes = useStyles();
  return (
    <Box className={classes.main}>
      <Pagination
        renderItem={(item) => (
          <PaginationItem
            {...item}
            classes={{ root: classes.paginationItem, selected: classes.paginationSelected }}
          />
        )}
        count={listItem?.total_pages}
        page={listItem?.current}
        onChange={(e, page) => setPage(page)}
      />
    </Box>
  );
}
